<isp-form-button
  [button]="props.button$ | async"
  (btnClick)="handleButtonClick($event)"
></isp-form-button>
